import React from 'react';

const Settings = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">Settings Page</h1>
      <p>Manage your settings here.</p>
      {/* Add your content here */}
    </div>
  );
};

export default Settings;